import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 40px 0 80px;

  @media ${breakpoint.md} {
    padding: 80px 0 160px;
  }
`;

export const BookWrapper = styled.div`
  margin-top: 32px;

  @media ${breakpoint.md} {
    margin-top: 40px;
  }
`;
